import { render, staticRenderFns } from "./shiftManagementMainDialogCreateSpecialDays.vue?vue&type=template&id=ed80012e&scoped=true"
import script from "./shiftManagementMainDialogCreateSpecialDays.vue?vue&type=script&lang=js"
export * from "./shiftManagementMainDialogCreateSpecialDays.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementMainDialogCreateSpecialDays.vue?vue&type=style&index=0&id=ed80012e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed80012e",
  null
  
)

export default component.exports